module.exports = __webpack_public_path__ + "static/media/person-1-full.31929ef6.png";